import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteBookingRate,
    fetchBookingRates,
    importBookingRates,
    postBookingRate
} from '../../../../../api/bookingApi/bookingRates'
import { selectCurrentOrganization } from '../../../../../selectors/bookingSelectors/bookingCurrentOrganization'
import { selectEasymsRatesKV } from '../../../../../selectors/bookingSelectors/bookingEasymsSelector'
import { selectRates, selectRatesFetching } from '../../../../../selectors/bookingSelectors/bookingRates'
import RatesTable from './RatesTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class RatesTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        rates: PropTypes.array.isRequired,
        easymsRatesKV: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchBookingRates: PropTypes.func.isRequired,
        postBookingRate: PropTypes.func.isRequired,
        deleteBookingRate: PropTypes.func.isRequired,
        importBookingRates: PropTypes.func.isRequired,
        currentOrganization: PropTypes.number.isRequired
    }

    state = {
        ourId: '',
        remoteId: '',
        remoteName: ''
    }

    componentDidMount() {
        const params = { organizationId: this.props.currentOrganization }
        this.props.fetchBookingRates(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { organizationId: this.props.currentOrganization }
            this.props.fetchBookingRates(params)
            this.setState({ ourId: '' })
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId, remoteId, remoteName } = this.state
        this.props.postBookingRate({
            organizationId: this.props.currentOrganization,
            ourId,
            remoteId: remoteId.trim(),
            remoteName: remoteName.trim()
        })
        this.setState({
            ourId: '',
            remoteId: '',
            remoteName: ''
        })
    }

    handleDelete = remoteId => {
        this.props.deleteBookingRate(remoteId)
    }

    handleUpdate = rate => {
        this.props.postBookingRate({
            organizationId: this.props.currentOrganization,
            ourId: rate.ourId,
            remotePropertyId: rate.remotePropertyId,
            remoteId: rate.remoteId,
            remoteName: rate.remoteName
        })
    }

    handleLoadImport = () => {
        this.props.importBookingRates()
    }

    render() {
        const { classes, fetching, rates, currentOrganization, easymsRatesKV } = this.props
        const { ourId, remoteId, remoteName } = this.state

        const valid = ourId && remoteId.trim() && remoteName.trim()

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Тариф EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsRatesKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-id">ID тарифу Booking.com</InputLabel>
                        <Input id="rates-remote-id" name="remoteId" value={remoteId} onChange={this.handleChange} />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="rates-remote-name">Імʼя тарифу Booking.com</InputLabel>
                        <Input
                            id="rates-remote-name"
                            name="remoteName"
                            value={remoteName}
                            onChange={this.handleChange}
                        />
                    </FormControl>

                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>

                <Button
                    disabled={!currentOrganization}
                    variant="raised"
                    color="primary"
                    className={classes.button}
                    onClick={this.handleLoadImport}
                >
                    Імпортувати тарифи з Booking.com
                </Button>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <RatesTable rates={rates} onDelete={this.handleDelete} onUpdate={this.handleUpdate} />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        rates: selectRates(state),
        fetching: selectRatesFetching(state),
        currentOrganization: selectCurrentOrganization(state),
        easymsRatesKV: selectEasymsRatesKV(state)
    }),
    { fetchBookingRates, postBookingRate, deleteBookingRate, importBookingRates }
)(withStyles(styles)(RatesTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/RatesTab/RatesTab.js